import {
  type ReservedSlugsResponse,
  reservedSlugsResponseDto,
  type UpdateReservedSlugsBody,
} from '@planuze/admin-contracts';
import { ApiError, parseJson, readErrorCode, request } from './http.js';

/* Cliente REST dos slugs reservados (ADR-0484). GET lê a lista LIVE do config-service; PUT
   (super_admin) substitui a lista inteira via read-modify-write no admin-service. */

async function reservedError(res: Response): Promise<ApiError> {
  const code = await readErrorCode(res);
  return new ApiError(res.status, 'server_error', code || 'request failed', code);
}

export async function getReservedSlugs(): Promise<readonly string[]> {
  const res = await request('/v1/admin/reserved-slugs');
  if (!res.ok) throw await reservedError(res);
  return (await parseJson(res, reservedSlugsResponseDto)).slugs;
}

export async function updateReservedSlugs(
  body: UpdateReservedSlugsBody,
): Promise<ReservedSlugsResponse> {
  const res = await request('/v1/admin/reserved-slugs', { method: 'PUT', body });
  if (!res.ok) throw await reservedError(res);
  return parseJson(res, reservedSlugsResponseDto);
}
